<template>
  <div
    class="content content-login-block w-100 d-flex justify-content-center align-items-center flex-column position-relative m-auto"
  >
    <div class="logo-top">
      <router-link to="/">
        <img :src="logo" class="logo-top my-5" />
      </router-link>
    </div>
    <div class="row content-body login-body align-items-center">
      <div class="col-lg-12 col-md-12 col-sm-12 my-4">
        <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12 my-4">
            <div class="text-center">
              <p class="title">
                {{ $t("veterinaire_forget_password.description_line1") }}<br />
              </p>
              <p class="slogan">{{ $t("veterinaire_forget_password.description_line2") }}<br /></p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-9 my-2">
            <div class="mx-auto form-reset d-flex flex-column">
              <input
                type="text"
                v-model="email"
                class="mb-4"
                :placeholder="$t('veterinaire_forget_password.placeholder.email')"
              />
              <button
                class="btn text-white btn-reset w-100 mb-4"
                id="reset"
                @click.prevent="handleResetPassword"
                :disabled="isLoading"
              >
                {{ $t("veterinaire_forget_password.buttons.reset_password") }}
              </button>
              <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
              <div v-if="infoMessage" class="alert alert-success">
                <span class="info-message mt-4">{{ infoMessage }}</span>
              </div>
              <div class="row">
                <router-link to="/login-veterinaire" class="back-login col-lg-6 col-md-6 col-sm-6"
                  ><img :src="prev" class="me-1" />{{
                    $t("veterinaire_forget_password.links.previous_step")
                  }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ForgetPassword } from "@/api/auth";
  import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
  import $ from "jquery";
  import prev from "@/assets/images/icon-prev.svg";

  export default {
    name: "ProprietaireForgetPassword",
    data() {
      return {
        logo,
        email: "",
        errorMessage: null,
        isLoading: false,
        canReset: true,
        infoMessage: "",
        prev,
      };
    },
    mounted() {
      const token = localStorage.getItem("token");
      if (token) {
        // this.$router.push('/dashboard/products');
      }
    },
    methods: {
      async handleResetPassword() {
        this.errorMessage = "";
        this.isLoading = true;
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
          this.$t("veterinaire_forget_password.loading");

        $("#reset").html(spinner);
        this.CheckValidateEmail();
        if (this.canReset)
          ForgetPassword(this.email)
            .then(() => {
              $("#reset").text(this.$t("veterinaire_forget_password.buttons.reset_password"));
              this.isLoading = false;
              this.infoMessage = this.$t("veterinaire_forget_password.messages.info_check_email");
              setTimeout(() => {
                this.infoMessage = "";
              }, 5000);
            })
            .catch(res => {
              this.isLoading = false;
               if (res.response && res.response.data && res.response.data.code === 401) {
                 this.errorMessage = "Aucun compte vétérinaire n'est rattaché à cet email.";
               } else {
                 this.errorMessage = 'Un problème est survenu. Veuillez réessayer plus tard.';
               }
              
              $("#reset").text(this.$t("veterinaire_forget_password.buttons.reset_password"));
            });
      },
      CheckValidateEmail() {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (this.email == "") {
          this.errorMessage = this.$t("veterinaire_forget_password.errors.email_required");
          this.canReset = false;
        } else {
          if (!regexEmail.test(this.email)) {
            this.errorMessage = this.$t("veterinaire_forget_password.errors.email_invalid");
            this.canReset = false;
          }
        }

        if (!this.canReset) {
          this.isLoading = false;
          $("#reset").text(this.$t("veterinaire_forget_password.buttons.reset_password"));
        }
      },
    },
  };
</script>
<style scoped>
  .reset-body {
    position: relative;
    height: 100%;
  }
  .top-logo {
    text-align: end;
  }
  .top-logo img {
    margin-right: 20px;
  }

  .reset-body .title {
    color: #1e347d;
    font-size: 18px;
    font-weight: bold;
    line-height: 29px;
  }
  .form-reset {
    input {
      height: 40px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 2px solid #aeb1ba;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    input:focus {
      border-color: #c9cfde;
      box-shadow: 0 0 8px #c9cfde;
      transform: scale(1.05);
      outline: none;
    }
  }
  .btn-reset {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 19px;
    text-align: center;
    font: normal normal bold 19px/25px DM Sans;
    letter-spacing: 0px;
  }
  .checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
  }

  .checkbox-container input {
    display: none; /* Cache l'input natif */
  }

  .checkmark {
    width: 22px;
    height: 22px;
    border: 2px solid #666;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    position: relative;
  }

  .checkmark::after {
    content: "";
    width: 10px;
    height: 15px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  /* Animation au clic checkbox*/
  .checkbox-container input:checked + .checkmark {
    background-color: #ec621a;
    border-color: #ec621a;
    transform: scale(1.1);
  }

  .checkbox-container input:checked + .checkmark::after {
    opacity: 1;
  }

  /* Effet rebond */
  .checkbox-container input:checked + .checkmark {
    animation: bounce 0.3s ease-in-out;
  }

  @keyframes bounce {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1.1);
    }
  }
  .back-login {
    color: #1e347d;
    font-size: 16px;
    font-weight: 600;
  }
  .btn-register,
  .btn-register:hover {
    background: #c9cfde 0% 0% no-repeat padding-box;
    border-radius: 76px;
    font-size: 19px;
    text-align: center;
    font: normal normal bold 19px/25px DM Sans;
    letter-spacing: 0px;
    color: #1e347d;
  }
  .alert {
    border-radius: 4px;
    color: #515a6e;
    font-size: 18px;
    line-height: 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .error-message {
    color: red;
    margin-left: 8px;
  }
  .alert-success {
    background-color: #edfff3;
    border: 1px solid #8ce6b0;
  }
  .info-message {
    margin-left: 8px;
  }
</style>
